module.exports = __webpack_public_path__ + "static/media/STEP-02.f18dfa22.png";